import React from "react";

interface FindRoutesButtonProps {
  onClick: () => Promise<void>;
  disabled?: boolean;
  isLoading: boolean;
}

const FindRoutesButton: React.FC<FindRoutesButtonProps> = ({
  onClick,
  disabled = false,
  isLoading,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`find-routes-button ${isLoading ? "loading" : ""}`}
      data-testid="find-routes"
      aria-busy={isLoading}
      aria-label="Find transit routes"
    >
      Find Routes
    </button>
  );
};

export default FindRoutesButton;
